import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';
import userAreaRoutes from '@/router/userAreaRoutes';
import errorRoutes from '@/router/errorAreaRutes';
import repoAreaRoutes from '@/router/repoAreaRoutes';
import unloggedAreaRutes from '@/router/unloggedAreaRutes';

const routes: Array<RouteRecordRaw> = [
  { path: '/:pathMatch(.*)*', redirect: '/' },
  ...unloggedAreaRutes,
  ...userAreaRoutes,
  ...repoAreaRoutes,
  ...errorRoutes,
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  next();
});

router.afterEach((to) => {
    if (to.hash) {
      // Wait for the DOM to update, then scroll to the anchor
      return new Promise((resolve) => {
        setTimeout(() => {
          const el = document.querySelector(to.hash);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
            resolve({ el: to.hash });
          } else {
            resolve({ top: 0 });
          }
        }, 300);
      });
    }
    // Default scroll to top
    return { top: 0 };
});

export default router;
